import React from 'react';
import { Download, Facebook, MessageSquare, Link2, Share2 } from 'lucide-react';
import { toast } from 'sonner';

const BASE = process.env.REACT_APP_BACKEND_URL;
const btn = 'inline-flex items-center gap-2 px-4 py-2.5 rounded-sm text-xs font-heading tracking-widest transition-colors';

export const JournalActions = ({ keyParam }) => {
  const url = `${window.location.origin}/digital-journal`;
  const text = 'Flip through the CBTU Region III 2026 Digital Ad Journal';
  const pdf = `${BASE}/api/journal-book/pdf${keyParam ? `?key=${encodeURIComponent(keyParam)}` : ''}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast.success('Link copied.'); } catch { toast.error('Could not copy the link.'); }
  };
  const nativeShare = () => navigator.share({ title: 'CBTU Region III Digital Ad Journal', text, url }).catch(() => {});

  return (
    <div className="mt-8 flex flex-wrap items-center justify-center gap-3" data-testid="journal-actions">
      <a href={pdf} className={`${btn} gold-button`} data-testid="journal-download-pdf"><Download size={14} /> DOWNLOAD PDF</a>
      <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer" className={`${btn} bg-[#1877f2] hover:bg-[#166fe5] text-white`} data-testid="journal-share-facebook"><Facebook size={14} /> SHARE ON FACEBOOK</a>
      <a href={`sms:?&body=${encodeURIComponent(`${text}: ${url}`)}`} className={`${btn} ghost-button`} data-testid="journal-share-text"><MessageSquare size={14} /> TEXT A FRIEND</a>
      <button type="button" onClick={copy} className={`${btn} ghost-button`} data-testid="journal-copy-link"><Link2 size={14} /> COPY LINK</button>
      {typeof navigator !== 'undefined' && navigator.share && (
        <button type="button" onClick={nativeShare} className={`${btn} ghost-button`} data-testid="journal-native-share"><Share2 size={14} /> SHARE</button>
      )}
    </div>
  );
};
